import { convertLanguageToISOCode } from "@/lib/language-to-iso-code"
import { Language, SteeringLevelValue } from "@/types/__generated__/union-types"

const SteeringLevelIcon = ({
  level,
  language,
  levelValue,
}: {
  level: SteeringLevelValue
  language: Language
  levelValue: number
}) => {
  let levelFormatClass = ""

  switch (level) {
    case "MINUS_ONE":
    case "ZERO":
    case "ONE":
      levelFormatClass = "text-on-success-surface bg-success-surface-subdued"
      break
    case "TWO":
      levelFormatClass = "text-on-warning-surface bg-warning-surface-subdued"
      break
    case "THREE":
      levelFormatClass = "text-on-critical-surface bg-critical-surface"
      break
    case "FOUR":
      levelFormatClass = "text-on-critical bg-critical"
      break
  }

  return (
    <div
      data-testid={`${language.toLowerCase()}-steering-level-icon`}
      className={`track-[0.25px] flex h-5 w-12 shrink-0 items-center justify-center rounded-sm text-center text-xs leading-4 font-normal ${levelFormatClass}`}>
      {`${convertLanguageToISOCode(language)}: ${levelValue}`}
    </div>
  )
}
export { SteeringLevelIcon }
